import React, { useState } from 'react';
import { ChevronDown, ChevronUp, BoxIcon } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/Card';
import { Button } from './ui/Button';
interface CompetencyCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  projects: string[];
  tools: string[];
  achievements: string[];
}
export function CompetencyCard({
  title,
  description,
  icon: Icon,
  projects,
  tools,
  achievements
}: CompetencyCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <Card className="transition-all duration-300 hover:shadow-md border-l-4 border-l-primary/50 hover:border-l-primary" data-id="element-1">
      <CardHeader className="cursor-pointer" onClick={() => setIsExpanded(!isExpanded)} data-id="element-2">
        <div className="flex items-center justify-between" data-id="element-3">
          <div className="flex items-center gap-4" data-id="element-4">
            <div className="p-2 rounded-full bg-primary/10 text-primary" data-id="element-5">
              <Icon className="w-6 h-6" data-id="element-6" />
            </div>
            <div data-id="element-7">
              <CardTitle data-id="element-8">{title}</CardTitle>
              <CardDescription className="mt-1" data-id="element-9">{description}</CardDescription>
            </div>
          </div>
          <Button variant="ghost" size="icon" aria-label={isExpanded ? 'Collapse' : 'Expand'} data-id="element-10">
            {isExpanded ? <ChevronUp className="w-4 h-4" data-id="element-11" /> : <ChevronDown className="w-4 h-4" data-id="element-12" />}
          </Button>
        </div>
      </CardHeader>

      {isExpanded && <CardContent className="animate-accordion-down overflow-hidden" data-id="element-13">
          <div className="pt-2 space-y-6 border-t mt-2" data-id="element-14">
            <div data-id="element-15">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-16">
                Key Projects
              </h4>
              <ul className="space-y-2" data-id="element-17">
                {projects.map((project, idx) => <li key={idx} className="flex items-start gap-2 text-sm" data-id="element-18">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 shrink-0" data-id="element-19" />
                    {project}
                  </li>)}
              </ul>
            </div>

            <div data-id="element-20">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-21">
                Tools & Tech
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-22">
                {tools.map((tool, idx) => <span key={idx} className="px-2.5 py-1 rounded-md bg-secondary text-secondary-foreground text-xs font-medium" data-id="element-23">
                    {tool}
                  </span>)}
              </div>
            </div>

            <div data-id="element-24">
              <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-3" data-id="element-25">
                Achievements
              </h4>
              <ul className="space-y-2" data-id="element-26">
                {achievements.map((achievement, idx) => <li key={idx} className="flex items-start gap-2 text-sm" data-id="element-27">
                    <span className="text-green-500 font-bold" data-id="element-28">✓</span>
                    {achievement}
                  </li>)}
              </ul>
            </div>
          </div>
        </CardContent>}
    </Card>;
}